import { ReactNode } from 'react';
import Box, { Flex } from '@spotnana/pixel-react/dist/Box';
import { Typography } from '@spotnana/blocks/src/Typography';

interface CardDetailItemProps {
  title: string;
  children: ReactNode;
}

const FlightSegmentContainer = ({ title, children }: CardDetailItemProps): JSX.Element => (
  <Box flexGrow={1} mt="32px">
    <Flex justifyContent="space-between" alignItems="center">
      <Typography style={{ textTransform: 'uppercase' }} as="h3" variant="body3" kind="medium" color="secondary">
        {title}
      </Typography>
    </Flex>
    <Box mt="2">{children}</Box>
  </Box>
);

export default FlightSegmentContainer;
